// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"1d9277fd","977":"38241185"}[chunkId] + ".chunk.js";
};